import { render, staticRenderFns } from "./zip-group.vue?vue&type=template&id=438b78f8"
import script from "./zip-group.vue?vue&type=script&lang=js"
export * from "./zip-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports